import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';

import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { STATE__collections } from '../STATE__collections';

export const REMOTE__collection_get_recent_images_urls = createAsyncThunkSafe<string[], void>(
  ENUM__network_event_client_to_server.COLLECTION_GET_RECENT_IMAGES_URLS,
  async (): Promise<string[]> => {
    return await send_to_server(ENUM__network_event_client_to_server.COLLECTION_GET_RECENT_IMAGES_URLS);
  },
);

export function INIT_REMOTE__collection_get_recent_images_urls(builder: ActionReducerMapBuilder<STATE__collections>) {
  builder
    .addCase(REMOTE__collection_get_recent_images_urls.pending, (state, action) => {})
    .addCase(REMOTE__collection_get_recent_images_urls.rejected, (state, action) => {})
    .addCase(REMOTE__collection_get_recent_images_urls.fulfilled, (state, action: PayloadAction<string[]>) => {});
}
